module.exports = __webpack_public_path__ + "img/icon.16929ad4.png";